import { render, staticRenderFns } from "./WaitingExaminationModal.vue?vue&type=template&id=2644ce0e&scoped=true"
import script from "./WaitingExaminationModal.vue?vue&type=script&lang=js"
export * from "./WaitingExaminationModal.vue?vue&type=script&lang=js"
import style0 from "./WaitingExaminationModal.vue?vue&type=style&index=0&id=2644ce0e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2644ce0e",
  null
  
)

export default component.exports